import type { BattleEvent, BattlePhase, BattleSnapshot, InputFrame } from '../../core';

export const BATTLE_TRACE_CAPACITY = 600;
export interface BattleTraceFighter {
  readonly state: string; readonly hp: number; readonly gauge: number; readonly attackId: string | null; readonly input: InputFrame;
}
export interface BattleTraceEntry {
  readonly logicalFrame: number; readonly battlePhase: BattlePhase; readonly timerFrames: number;
  readonly p1: BattleTraceFighter; readonly p2: BattleTraceFighter; readonly eventTypes: readonly string[];
  readonly activeCinematicId: string | null;
}

const cloneInput = (input: InputFrame): InputFrame => Object.freeze({ ...input });
const fighter = (snapshot: BattleSnapshot, player: 0 | 1, input: InputFrame): BattleTraceFighter => Object.freeze({
  state: snapshot.characters[player].state, hp: snapshot.characters[player].hp, gauge: snapshot.characters[player].gauge,
  attackId: snapshot.characters[player].currentAttackId, input: cloneInput(input),
});

export class BattleTrace {
  private entries: BattleTraceEntry[] = [];
  public constructor(public readonly capacity = BATTLE_TRACE_CAPACITY) { if (!Number.isInteger(capacity) || capacity <= 0) throw new RangeError('Trace capacity must be positive.'); }
  public record(snapshot: BattleSnapshot, inputs: readonly [InputFrame, InputFrame], events: readonly BattleEvent[]): void {
    const entry: BattleTraceEntry = Object.freeze({
      logicalFrame: snapshot.logicalFrame, battlePhase: snapshot.battlePhase, timerFrames: snapshot.timerFrames,
      p1: fighter(snapshot, 0, inputs[0]), p2: fighter(snapshot, 1, inputs[1]),
      eventTypes: Object.freeze(events.map((event) => event.type)), activeCinematicId: snapshot.activeCinematicId,
    });
    if (this.entries.length === this.capacity) this.entries.shift(); this.entries.push(entry);
  }
  public getEntries(): readonly BattleTraceEntry[] { return Object.freeze([...this.entries]); }
  public clear(): void { this.entries = []; }
}
